import { render, staticRenderFns } from "./PhotoEditor.vue?vue&type=template&id=cb2d6b58&scoped=true&"
import script from "./PhotoEditor.vue?vue&type=script&lang=js&"
export * from "./PhotoEditor.vue?vue&type=script&lang=js&"
import style0 from "./PhotoEditor.vue?vue&type=style&index=0&id=cb2d6b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2d6b58",
  null
  
)

export default component.exports